import {
  call, put, takeLatest, select, all, take, takeEvery, delay,
} from 'redux-saga/effects';
import { change, untouch } from 'redux-form';
import $ from 'jquery';
import { callApi } from './loadingSaga';
import Api from '../api/campEntryApi';
import * as Actions from '../actions/campEntryActions';

const SUCCESS_GET_RENTALS = 'SUCCESS_GET_RENTALS';

export function* initalizeCampForm(action) {
  yield put(Actions.setCampId(action.payload.campId));
  const { initial } = yield select((state) => state.form.campEntryCamp);

  const planId = initial.parent_status?.student_statuses_attributes?.[0]?.plan_id;
  if (planId === undefined || planId === 'お選びください') return;

  yield put({ type: Actions.SAGA_GET_STAY_PLANS, payload: { planId } });
  if (initial.parent_status.student_statuses_attributes[0].stayplan_id) {
    yield put({
      type: Actions.SAGA_GET_PLAN_STAYPLAN_MEETING_TIMES,
      payload: { planId, stayplanId: initial.parent_status.student_statuses_attributes[0].stayplan_id },
    });
  }
  // 編集時: 現在選択中のコースが非アクティブでもリストに含める
  const includeCourseId = initial.parent_status?.student_statuses_attributes?.[0]?.course_id;
  yield put({ type: Actions.SAGA_GET_COURSES, payload: { planId, includeCourseId } });
  yield put({ type: Actions.SAGA_GET_PAYMENTS });

  const courseId = initial.parent_status?.student_statuses_attributes?.[0]?.course_id;
  if (courseId === undefined || courseId === 'お選びください') return;

  yield put({ type: Actions.SAGA_GET_RENTALS, payload: { courseId } });

  while (true) {
    yield take(SUCCESS_GET_RENTALS);
    // HACK: クーポン価格反映のための遅延処理
    // TODO: getPricesAPIの引数を表示されたフォームの値ではなくjsonに変更した後削除
    yield delay(2000);
    yield put({ type: Actions.SAGA_GET_PRICES });
  }
}

export function* getStayPlans(action) {
  const { stayplans } = yield call(callApi, Api.getStayPlans, action.payload.planId);
  yield put(Actions.setStayPlans(stayplans));
}

export function* getPlanStayplanMeetingTimes(action) {
  const { meetingTimes } = yield call(callApi, Api.getPlanStayplanMeetingTimes, action.payload.planId, action.payload.stayplanId);
  yield put(Actions.setPlanStayplanMeetingTimes(meetingTimes));
}

export function* getCourses(action) {
  const { planCourses } = yield call(callApi, Api.getCourses, action.payload.planId, action.payload.includeCourseId);
  yield put(Actions.setCourses(planCourses));
}

export function* getPayments() {
  const { campId } = yield select((state) => state.campEntry);
  const { paymentMethods } = yield call(callApi, Api.getPayments, campId);
  yield put(Actions.setPayments(paymentMethods));
}

export function* getRentals(action) {
  const { campId } = yield select((state) => state.campEntry);
  const { plan_id, pc_rental } = yield select((state) => state.form.campEntryCamp.values.parent_status.student_statuses_attributes[0]);
  if (pc_rental === true || pc_rental === 'true') {
    yield put({ type: SUCCESS_GET_RENTALS });
  }
  const { rentals } = yield call(callApi, Api.getRentals, campId, plan_id, action.payload.courseId);
  yield put(Actions.setRentals(rentals));
  yield all(rentals.map((rental, index) => put(change('campEntryCamp', `parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][camp_rental_id]`, rental.id))));
  const { pcTypes } = yield call(callApi, Api.getPcTypes, action.payload.courseId);
  yield put(Actions.setPcTypes(pcTypes));
  yield put({ type: SUCCESS_GET_RENTALS });
  return rentals;
}
export function* getPrices() {
  const { values } = yield select((state) => (state.form.campEntryCamp === undefined ? state.form.Credit : state.form.campEntryCamp));
  let prices = {};
  const studentStatus = values.parent_status?.student_statuses_attributes?.[0] || {};
  const {
    plan_id, stayplan_id, pc_rental, student_status_camp_rentals_attributes,
  } = studentStatus;
  if (plan_id !== undefined && stayplan_id !== undefined
      && (pc_rental === 'true' || (
        student_status_camp_rentals_attributes !== undefined
        && Object.keys(student_status_camp_rentals_attributes).length > 0
        && Object.keys(student_status_camp_rentals_attributes).map((key) => student_status_camp_rentals_attributes[key]).every((x) => x == null || x.use_rental != null || x.camp_rental_id === '-1')))
  ) {
    prices = yield call(callApi, Api.getPrices, values);
    const { campEntryCamp } = yield select((state) => state.form);
    if (campEntryCamp !== undefined) {
      const { payment_id } = yield select((state) => state.form.campEntryCamp.values.parent_status);
      if (!$.isEmptyObject(prices) && prices.price === 0 && payment_id !== 3) {
        yield put(change('campEntryCamp', 'parent_status[payment_id]', 3));
      }
    }
  }

  yield put(Actions.setPrices(prices));
}

function* onChangeCampForm(action) {
  const { field } = action.meta;
  switch (field) {
    case 'parent_status[student_statuses_attributes][0][plan_id]':
      if (action.payload === undefined || action.payload === 'お選びください') {
        yield put(Actions.setStayPlans([]));
        yield put(Actions.setCourses([]));
        yield put(Actions.setPayments([]));
      } else {
        yield put({
          type: Actions.SAGA_GET_STAY_PLANS,
          payload: { planId: action.payload.toString() },
        });
        yield put({
          type: Actions.SAGA_GET_COURSES,
          payload: { planId: action.payload.toString() },
        });
        yield put({
          type: Actions.SAGA_GET_PAYMENTS,
        });
      }
      yield put(untouch('campEntryCamp', 'parent_status[student_statuses_attributes][0][plan_id]'));
      yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][stayplan_id]', undefined));
      break;
    case 'parent_status[student_statuses_attributes][0][stayplan_id]':
      if (action.payload === undefined || action.payload === 'お選びください') {
        yield put(untouch('campEntryCamp', 'parent_status[student_statuses_attributes][0][stayplan_id]'));
        yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][course_id]', undefined));
      } else {
        const { plan_id } = yield select((state) => state.form.campEntryCamp.values.parent_status.student_statuses_attributes[0]);
        yield put({
          type: Actions.SAGA_GET_PLAN_STAYPLAN_MEETING_TIMES,
          payload: { planId: plan_id, stayplanId: action.payload },
        });
      }
      break;
    case 'parent_status[student_statuses_attributes][0][course_id]':
      if (action.payload === undefined || action.payload === 'お選びください') {
        yield put(Actions.setRentals([]));
      } else {
        yield put({
          type: Actions.SAGA_GET_RENTALS,
          payload: { courseId: action.payload },
        });
      }

      yield put(untouch('campEntryCamp', 'parent_status[student_statuses_attributes][0][course_id]'));
      yield put(change('campEntryCamp', 'parent_status[payment_id]', undefined));
      yield put(Actions.setPrices({}));

      // eslint-disable-next-line no-unreachable-loop -- saga take pattern, intentionally runs once
      while (true) {
        yield take(SUCCESS_GET_RENTALS);
        const { rentals } = yield select((state) => state.campEntry);
        const { student_statuses_attributes: initial_student_statuses_attributes } = yield select((state) => state.form.campEntryCamp.initial.parent_status);
        const { student_status_camp_rentals_attributes } = yield select((state) => state.form.campEntryCamp.values.parent_status.student_statuses_attributes[0]);

        // レンタルが2 -> 1に変更になった時の処理
        if (rentals.length === 1 && student_status_camp_rentals_attributes.length === 2) {
          yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][use_rental]', null));

          // initialValueにcamp_rentalsのidが入っていた時の処理
          if (initial_student_statuses_attributes?.[0]?.student_status_camp_rentals_attributes?.[1]?.id !== undefined) {
            yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1][use_rental]', false));
            yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1][camp_rental_id]', -1));
          } else {
            yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1]', null));
          }
        } else {
          yield all(rentals.map((_, index) => put(change('campEntryCamp', `parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][${index}][use_rental]`, null))));
        }
        return;
      }
    case 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][0][use_rental]': {
      const { rentals } = yield select((state) => state.campEntry);
      if (rentals.length > 1) {
        yield put(change('campEntryCamp', 'parent_status[student_statuses_attributes][0][student_status_camp_rentals_attributes][1][use_rental]', action.payload === 'true' ? 'true' : null));
      }
      break;
    }
    case 'parent_status[payment_id]':
      if (action.payload === undefined || action.payload === 'お選びください') {
        yield put(untouch('campEntryCamp', 'parent_status[payment_id]'));
      } else {
        yield put(Actions.setPeymentId(action.payload));
      }
      break;
    default:
      break;
  }
  // FIXME: 余計な処理となっているので外す
  yield put({ type: Actions.SAGA_GET_PRICES });
}

export function* onChangeFormInput(action) {
  const { form } = action.meta;
  if (form === 'campEntryCamp') {
    yield call(onChangeCampForm, action);
  }
}

export function* isCouponExist(action) {
  const { couponError } = yield select((state) => state.campEntry);
  if (couponError !== undefined) {
    yield call(action.reject, { any_code: couponError });
  } else {
    yield call(action.resolve);
  }
}

export default function* campEntrySaga() {
  yield takeLatest(Actions.SAGA_INITIALZE_CAMP_FORM, initalizeCampForm);
  yield takeLatest(Actions.SAGA_GET_STAY_PLANS, getStayPlans);
  yield takeLatest(Actions.SAGA_GET_PLAN_STAYPLAN_MEETING_TIMES, getPlanStayplanMeetingTimes);
  yield takeLatest(Actions.SAGA_GET_COURSES, getCourses);
  yield takeLatest(Actions.SAGA_GET_PAYMENTS, getPayments);
  yield takeLatest(Actions.SAGA_GET_RENTALS, getRentals);
  yield takeLatest(Actions.SAGA_GET_PRICES, getPrices);
  yield takeEvery('@@redux-form/CHANGE', onChangeFormInput);
  yield takeLatest(Actions.SAGA_IS_COUPON_ERROR_EXIST, isCouponExist);
}
